import { render } from "./Payment.vue?vue&type=template&id=789f8660&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=789f8660&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-789f8660"

export default script